import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const Container = styled.div`
    height:auto;
    margin: 0 22.05px 0 22.3px;
    width: 358px;
    border-radius: 7px;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px #00000029;
    opacity: 1;
    overflow-y: hidden;
    margin: 8px 16px 16px 16px;
    padding: 16px;

    @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
        padding-bottom: 200px;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {  
        padding-bottom: 200px;
    }

    @media screen and (min-device-width: 990px) and (max-device-width: 1100px) and (orientation: landscape) {  
        padding-bottom: 200px;
    }

    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape) {  
        padding-bottom: 200px;
    }

    @media only screen and (min-width: 1110px) and (max-width: 1122px) and (orientation: landscape) {
        padding-bottom: 200px;
    }

    
    ${media.mediumDevice`
        margin: 8px 16px 16px 16px;
    `}
    ${media.smalDevice`
        margin: 8px 16px 16px 16px;
    `}
    ${media.mobileDevice`
        width: 100%;
        margin: 5px 16px 16px 16px;
        // height: calc(100vh - 150px);
        // overflow-y: scroll;
        height: auto;
    `}
    @media (min-height: 850px) and (max-height: 900px){
        height: 720px;
    }
    @media (min-height: 650px) and (max-height:700px){
        height: 520px;
    }
`;
export const FilterContentMain = styled.div`
    display: flex;
    flex-direction: column;
    background: #f5f5f5 !important;
    height: 100vh;
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    ${scrollBarStyle}
    
`;
export const FilterWrapperMain = styled.div`
    width: 397px;
    height: ${({bannerHeight}) =>
        bannerHeight ? `calc(68vh - ${bannerHeight})` : '68vh'};
    background: #f5f5f5;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #dcdcdc;
    border-radius: 6px;
    opacity: 1;
    overflow-y: hidden;
    flex-direction: column;
    position: relative;
    align-self: center;
    z-index: 3000;
    webkit-scrollbar {
        display: none;
    }
    ${media.mediumDevice`
        width: 360px;
    `}
    ${media.mobileDevice`
		height: 100vh;
		width: 100vw;
		max-width: none;
        overflow-y: scroll;
    `}
    @media only screen and (min-device-width: 370px) and (max-device-width: 950px) and (orientation : landscape) {
        height: 63vh;
    }
`;
export const DetailsMainContainerBlock = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;
